import { z } from "zod";

import { httpHeaderSchema } from "../shared";

import { authenticationTypeSchema } from "./authentication-type-schema";
import { eventTypeSchema } from "./event-type-schema";
import { oAuthConfigSchema } from "./oauth-config-schema";
import { producerTypeSchema } from "./producer-type-schema";

export const subscriptionSchema = z.object({
	id: z.string(),
	name: z.string(),
	sendThroughIot: z.boolean(),
	ignoreCertificateErrors: z.boolean().optional().default(false),
	eventTypes: z.array(eventTypeSchema),
	headers: z.array(httpHeaderSchema),
	producerSettings: z.record(z.string(), z.string()),
	producerType: producerTypeSchema,
	excludedFields: z.array(z.string()),
	authenticationType: authenticationTypeSchema,
	oauth: oAuthConfigSchema.nullable(),
	secret: z.string().nullable(),
	basicAuthSecret: z.string().nullable(),
	failedMessageCount: z.number().optional(),
	isTestSubscription: z.boolean(),
});

export type Subscription = z.infer<typeof subscriptionSchema>;
